import React, { Component } from 'react';
import './App.css';
import { parseSchema, generateXml, generateXmlForGA, checkValidity } from './parseSchema';

import names from './names';

import ElementEditor from './ElementEditor';
import { isString } from 'util';

class App extends Component {
  schemaFile = 'schema.rng?v=1234';
  identifierPdf = 'gave-reference-ids.pdf';

  state = {
    data: {},
    names: {},
    values: {},
    dataReady: false
  };

  constructor(props) {
    super(props);

    fetch(props.publicPluginUrl + this.schemaFile)
    .then(response => response.text())
    .then(str => (new window.DOMParser()).parseFromString(str, "text/xml"))
    .then(data => {
      const schema = parseSchema(data);
      
      this.setState({
        data: schema,
        names: names,
        values: this.props.values || {},
        dataReady: true
      });
    });
  }
  
  getValueState() {
    return this.state.values;
  }

  save() {
    if (this.props.onSave) {
      this.props.onSave(this.getValueState());
    }
  }

  fillMirrorValues(map, mirrors) {
    Object.keys(mirrors || {}).forEach(source => {
      const target = mirrors[source];

      map.forEach((entry, ix) => {
        if (source in entry) {
          if (isString(target)) {
            map[ix][target] = entry[source].slice(0);
          }
          else {
            this.fillMirrorValues(entry, target);
          }
        }
      });
    });
    return map;
  }

  setValues(map) {
    Object.keys(this.props.mirrors || {}).forEach(source => {
      if (source in map) {
        const target = this.props.mirrors[source];

        if (isString(target)) {
          map[target] = map[source].slice(0);
        }
        else {
          this.fillMirrorValues(map[source], target);
        }
      }
    });

    this.setState({
      values: Object.assign({}, this.state.values, map)
    });
  }

  getXml() {
    var a = generateXml(this.state.data, this.state.values, this.props.defaults || {});
    return a;
  }

  getXmlForGA() {
    var a = generateXmlForGA(this.state.data, this.state.values, this.props.defaults || {});
    return a; 
  }

  openGA() {
    if (this.checkValidity()) {
      var gaOpenUrl = "epat://patientexport/default/gatest?partner=growthanalyzer&xml=" + encodeURIComponent(this.getXmlForGA());
      // window.location.href = gaOpenUrl
      if (window.epatConnectorSocket && window.epatConnectorSocket.connected) {
        window.epatConnectorSocket.emit('open-url', gaOpenUrl);
      }
      else {
        window.location.href = 'epat://start/1/1/1';
      }
    }
    else {
      window.alert("There are errors");
    }
  }

  checkValidity() {
    return checkValidity(this.state.data, this.state.values);
  }

  render() {
    const xml = this.state.dataReady ? this.getXml() : '';

    return (
      <div className="App growtheditor-app">
        <div className="flexbox-item flexbox-menu">
          <div className="nav flex stil3 dossier timer">
            <div className="left">
              <ul>
                <li className="level_1 first last" onClick={() => this.save()}>
                  <i className="fa fa-main fa-database"></i>
                  <span className="label">Save</span>
                </li>
              </ul>
            </div>
            <div className="right">
              <ul>
                <li className="level_1 first last" onClick={() => this.openGA()}>
                  <i className="fa fa-main fa-child"></i>
                  <span className="label">Open in GA</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div>
          {this.state.dataReady && <ElementEditor
            setValues={(map) => this.setValues(map)}
            data={this.state.data}
            names={this.state.names}
            values={this.state.values}
            prefills={this.props.prefills || {}}
            defaults={this.props.defaults || {}}
            publicPluginUrl={this.props.publicPluginUrl || '/'}
          />}
        </div>
        {this.props.debug && <div className="debug">
          <div style={{display:'flex'}}>
            <textarea style={{flex:1, height: '100px'}} value={JSON.stringify(this.state.values)}></textarea>
            <textarea style={{flex:1, height: '100px'}} value={xml}></textarea>
          </div>
        </div>}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js